import dayjs from "dayjs";
import {LOCALE} from "../config";
import {MaybeType} from "../types";

/**
 * util method to format contentful date string by locale
 * @param {string} contentfulDate
 * @return {string | null}
 */
export const formattedPublishDate = (
  contentfulDate: string
): string | undefined => {
  if (!contentfulDate) {
    return;
  }

  if (LOCALE === "zh-CN") {
    return dayjs(contentfulDate).format("YYYY 年 MM 月 DD 日");
  }

  return dayjs(contentfulDate).format("MMMM D, YYYY");
};

/**
 * helper method to construct webinar path
 * @param {string} slug
 * @return {string}
 */
export const webinarURL = (slug: string): string => {
  return `/webinars/${slug}`;
};

/**
 * helper method to construct webinar link
 * @param {object} webinar
 * @return {string}
 */
export const webinarLink = (webinar: {
  externalLink: MaybeType<string>;
  slug: MaybeType<string>;
}): string => {
  // Webinars can either be external resources (like Marketo pages) or
  // resources that we have internal pages for (/webinars/:webinar_id).
  // This function returns either a webinar's external URL or the internal URL
  // for a webinar
  return webinar.externalLink
    ? webinar.externalLink
    : webinarURL(webinar.slug || "");
};
